import * as z from 'zod';

export const clientSchema = z.object({
  clients: z.array(
    z.object({
      name: z
        .string()
        .min(3, "Name must be at least 3 characters long")
        .max(100, "Name must not exceed 100 characters"),
      bookingId: z.string().optional(),
      passportNumber: z.string().min(1, "Passport number is required"),
      birthDate: z.string().optional(),   // ISO date string or empty
      issueDate: z.string().optional(),
      expiredDate: z.string().optional(),
    })
  ),
});

export type ClientSchema = z.infer<typeof clientSchema>;
